import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import secureStorage from "../../config/encrypt";
import DealerService from '../../service/DealerService';
import AdminSubscriptionList from './AdminSubscriptionList';
import DealerSubscriptionList from './DealerSubscriptionList';
import ModalDealerTransactionDetails from './ModalDealerTransactionDetails';

const DealerSubscriptionPannel = (props) => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [buyOptions, setBuyOptions] = useState([]);
    const [activeSubscription, setActiveSubsciptons] = useState([]);
    const [skuTYpes, setSkuTypes] = useState([]);
    const [skuSubsciptionTypes, setSkuSubscriptionTypes] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10); // number of records per page
    const [totalPages, setTotalPages] = useState(1);
    const [showModal, setShowModal] = useState(false);

    const loginResponse = secureStorage.getItem('loginUserInfo');
    const userData = loginResponse && loginResponse.data && loginResponse.data.user_data || {};
    const dealerData = loginResponse && loginResponse.data && loginResponse?.data?.dealer_data || {};

    const roleData = loginResponse.data.user_data.role_data || [];
    const role_access = loginResponse && loginResponse.data && loginResponse.data.user_data && loginResponse.data.user_data.role_data && loginResponse.data.user_data.role_data.length > 0 ? loginResponse.data.user_data.role_data : []
    const userId = userData?.user_id || 0;
    const dealerIDHash = dealerData[0]?.dealer_id_hash || '';
    const dealerId = dealerData[0]?.dealer_id;

    const userRole = userData && userData?.role;
    const isAdmin = userRole === 'admin';
    
    useEffect(() => {
        fetchDealerSKUSubscriptionList();
        fetchSkuTypes();
    }, [props]);

     const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            fetchDealerSKUSubscriptionList(page);
        }
    };

    const fetchSkuTypes = async () => {
        try {
            const response = await DealerService.getMasters(["dealer_sku"]);
            if (response.status == 200 && response.data.status == 200) {
                let responsedata = response.data.data || {};
                if (responsedata.dealer_sku && responsedata.dealer_sku.length) {
                    let subscM = [], skuM = [];
                    // eslint-disable-next-line array-callback-return
                    responsedata.dealer_sku.map(v => {
                        if (v.sku_type == "subscription") subscM.push(v);
                        if (v.sku_type == "service") {
                            skuM.push({
                                value: v.id,
                                label: v.sku_name,
                            });
                        };
                    });

                    setSkuTypes(skuM);
                    setSkuSubscriptionTypes(subscM);
                }
            }
        } catch (error) {

        } finally {

        }
    };

    const fetchDealerSKUSubscriptionList = async (page=1) => {
        const paginationPayload = {
            page: page,
        };
        const payload = {
            dealer_id: dealerId || userId,
            user_role: userRole,
            ...paginationPayload
        };
        if (props?.dealer_id_hash) {
            payload['dealer_id_hash'] = props?.dealer_id_hash;
            payload['requested_by'] = 'admin';
        }
        setIsLoading(true);
        const skuResponse = await DealerService.getDealerSKUsSubscriptionList(payload);
        setIsLoading(false);
        if (skuResponse && skuResponse.status === 200) {
            const responseResult = skuResponse?.data && skuResponse?.data?.data;
            const available2Buy = responseResult?.available_to_buy && responseResult?.available_to_buy?.length > 0 ? responseResult?.available_to_buy : [];
            const activeSubscription = responseResult?.active_subscriptions && responseResult?.active_subscriptions?.length > 0 ? responseResult?.active_subscriptions : [];
            let paginationDetails = responseResult?.buyable_pagination || {};
            setBuyOptions(available2Buy);
            setActiveSubsciptons(activeSubscription);
            setTotalPages(paginationDetails?.total_pages);
        }
    };
    
    const handleViewClick = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleRenew = async (sub) => {
        setIsLoading(true)
        const payload = {
            amount: parseFloat(sub?.price),
            dealer_id_hash: dealerIDHash,
            packageId: String(sub.id),
            is_renewal: true
        };
        
        try {
            const response = await DealerService.createInvoice(payload);
            if (response && response?.status === 200 && response?.data && response?.data?.status === 200) {
                let result = response?.data;
                let data = result && result?.data;

                if (data?.invoice_url) {
                    window.location.href = data.invoice_url;
                }
            } else if (response?.data && response?.data?.status !== 200) {
                toast.error(response?.data?.message);
            }
        } catch (error) {
            console.log("Invoice creation failed:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className={isLoading ? "container-fluid new-theme loading" : "container-fluid new-theme"}>
                <div className='dealer-section dealer-card m-lg m-md-l m-md-r'>
                    {/* Active Subscriptions */}
                    {/* {userRole === 'dealercentral' && <div className="feature-box"> */}
                    {userRole === 'dealercentral' && <div className="feature-box">
                        <h2>Active Subscriptions</h2>
                        <div className='row'>
                            {activeSubscription && activeSubscription.map((sub, index) => (
                                <div className='col-md-4 m-lg-b'>
                                    <div className="feature-card m-xs-t p-rel" key={index}>
                                        <div className='d-flex justify-content-between'>
                                            <div>
                                                <span className="block vh-title">{sub.name}</span>
                                                <span className="vh-price">Expires on {sub.formatted_expiry}</span>
                                            </div>
                                            <div>
                                                <span className="block vh-title">Rp {sub.price.toLocaleString()}</span>
                                            </div>
                                        </div>
                                        <div className="row lead-used-panel">
                                            <div className="col-md-4">
                                                <span className="block lead-text">
                                                    {`Quota Used`}
                                                </span>
                                                <div className="lead-number"><span>{`${sub.quota_used} /${sub?.quota}`}</span></div>
                                            </div>
                                            {/* We'll enable this code when consumed lead service implemented in backend  */}
                                            {/* {<div className="col-md-4">
                                                <span className="block lead-text">
                                                    {`Lead Delivered`}
                                                </span>
                                                <div className="lead-number"><span>{`${5} /${sub?.total_leads}`}</span></div>
                                            </div>} */}
                                        </div>
                                    </div>
                                    {sub.package_status === 'pending' && <div className='expire-box text-center'>
                                        <span>Payment status from bank yet to be confirm.</span>
                                    </div>}
                                    {(sub.package_status === 'active' && sub?.remaining_days <= 3) && <div className='expire-box text-center'>
                                        <span>{`Expiring in ${sub?.remaining_days} Days`}</span>
                                        <Link to="/" 
                                            className='btn-solid w-auto btn-sm bg-orange renew-btn'
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleRenew(sub);
                                            }}
                                            disabled={isLoading}
                                        >
                                            Renew Now
                                        </Link>
                                    </div>}
                                </div>
                            ))}
                        </div>
                    </div>}

                    {/* Buy Subscriptions */}
                    {
                        isAdmin ? (
                            <AdminSubscriptionList
                                isLoading={isLoading}
                                buyOptions={buyOptions}
                                userRole={userRole}
                                skuTYpes={skuTYpes}
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                                activePackage={activeSubscription}
                                dealer_id_hash={props?.dealer_id_hash}
                                fetchDealerSKUSubscriptionList={fetchDealerSKUSubscriptionList}
                                fetchEditData={props?.fetchEditData}
                            />
                        ) : ['dealercentral'].includes(userRole) ? (
                            <DealerSubscriptionList
                                isLoading={isLoading}
                                buyOptions={buyOptions}
                                userRole={userRole}
                                skuTYpes={skuTYpes}
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                                activePackage={activeSubscription}
                                fetchEditData={props?.fetchEditData}
                            />
                        ) : null
                    }
                </div>

            </div>

            {/* Modal Dealer transaction detail */}
            <Modal show={showModal} onHide={handleCloseModal} className='modal-subscription modal-dealer-transaction' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Transaction Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalDealerTransactionDetails />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default DealerSubscriptionPannel;